import { render, staticRenderFns } from "./examenes.vue?vue&type=template&id=df2480aa&scoped=true"
import script from "./examenes.vue?vue&type=script&lang=js"
export * from "./examenes.vue?vue&type=script&lang=js"
import style0 from "./examenes.vue?vue&type=style&index=0&id=df2480aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2480aa",
  null
  
)

export default component.exports